<template>
  <div class="dischargeCapacity">
    <title1 type="1" title="养护类型" />
    <div style="width: 440px; height: 220px">
      <MyEcharts
        v-if="showcdata"
        :id="'smart3_3'"
        :options="option"
        style="width: 440px; height: 280px"
      />
    </div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title4";
import MyEcharts from "@/views/exposition/components/charts/echarts.vue";
import * as echarts from "echarts5";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    MyEcharts,
    title1,
  },
  data() {
    return {
      showcdata: false,
      // title:"月度充/放电量"
      cdata: {
        tooltip: {
          //雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip 不会随着鼠标移动而位置变化，不友好
          confine: true,
          enterable: true, //鼠标是否可以移动到tooltip区域内
        },
        // grid: {
        //   top: "23%",
        //   fontSize: 18,
        // },
        color: ["#FFCE51", "#82F2F4"],
        // xAxis: {
        //   type: "category",
        //   boundaryGap: false,
        //   data: [],
        // },
        // title: {
        //   text: "单位: %",
        // },
        // yAxis: {
        //   type: "value",
        //   nameTextStyle: {
        //     fontSize: 26,
        //   },
        // },

        radar: {
          splitNumber: 3, // 中间辅助线
          center: ["50%", "55%"], // 图表位置
          radius: "85%", // 图表大小
          // 设置雷达图中间射线的颜色
          // 设置雷达图中间射线的颜色
          axisLine: {
            lineStyle: {
              color: "rgba(242, 242, 242, .1)",
              fontSize: 40,
            },
          },

          // 网格线
          splitLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: "rgba(242, 242, 242, .08)",
            },
          },
          // 雷达图背景的颜色，在这儿随便设置了一个颜色，完全不透明度为0，就实现了透明背景
          splitArea: {
            areaStyle: {
              // 图表背景的颜色
              // color: ["#555555", "#444444", "#333333", "#222222"],
              color: ["rgba(2,18,25,0.6)"],

              shadowColor: "rgba(0,0,0,.15)",
              shadowBlur: 2,
            },
          },
          name: {
            // formatter: (a,b)=>{
            //                     i++;
            //                     return `{a|${a}}\n{b|${arr1[i]}}`
            //                 },

            textStyle: {
              color: "white",
              fontSize: 16,
              borderRadius: 3,
              //   padding: [3, 5],
            },
          },
          // shape: 'circle',
          indicator: [
            {
              name: "坑洼",
              value: 23.75,
              max: 50,
            },
            { name: "车辙", value: 15.39, max: 50 },
            { name: "其他", value: 8.31, max: 50 },
            { name: "裂纹", value: 29.32, max: 50 },
            { name: "变形", value: 23.23, max: 50 },
          ],
        },
        series: [
          {
            // name: "发电效率",
            type: "radar",
            // smooth: true,
            data: [
              {
                value: [23.75, 15.39, 8.31, 29.32, 23.23],
                name: "",
                symbol: "none",
                itemStyle: {
                  //该数值区域样式设置
                  normal: {
                    color: "#1AEFEF", //背景颜色，还需设置areaStyle
                    lineStyle: {
                      color: "#51DBDB", //边框颜色
                    },
                  },
                },
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      return params.value;
                    },
                  },
                },
              },
            ],
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(26, 239, 239, 0)",
                },
                {
                  offset: 1,
                  color: "#51DBDB",
                },
              ]),
            },
          },
        ],
      },
      query: this.$route.query,
      option: {
        title: {
          text: "",
        },
        tooltip: {},
        radar: {
          splitNumber: 3, // 中间辅助线
          center: ["50%", "55%"], // 图表位置
          radius: "85%", // 图表大小
          // 设置雷达图中间射线的颜色
          // 设置雷达图中间射线的颜色
          axisLine: {
            lineStyle: {
              color: "rgba(242, 242, 242, .1)",
              fontSize: 40,
            },
          },

          // 网格线
          splitLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: "rgba(242, 242, 242, .08)",
            },
          },
          // 雷达图背景的颜色，在这儿随便设置了一个颜色，完全不透明度为0，就实现了透明背景
          splitArea: {
            areaStyle: {
              // 图表背景的颜色
              // color: ["#555555", "#444444", "#333333", "#222222"],
              color: ["rgba(2,18,25,0.6)"],

              shadowColor: "rgba(0,0,0,.15)",
              shadowBlur: 2,
            },
          },
          name: {
            // formatter: (a,b)=>{
            //                     i++;
            //                     return `{a|${a}}\n{b|${arr1[i]}}`
            //                 },

            textStyle: {
              color: "white",
              fontSize: 16,
              borderRadius: 3,
              //   padding: [3, 5],
            },
          },
          indicator: [
            {
              name: "坑洼",
              max: 50,
            },
            { name: "车辙", max: 50 },
            { name: "其他", max: 50 },
            { name: "裂纹", max: 50 },
            { name: "变形", max: 50 },
            // { name: "苹果", max: 6500 },
            // { name: "西瓜", max: 16000 },
            // { name: "葡萄", max: 30000 },
            // { name: "哈密瓜", max: 38000 },
            // { name: "香蕉", max: 52000 },
            // { name: "桃", max: 25000 },
          ],
        },
        series: [
          {
            type: "radar",
            data: [
              {
                value: [23.75, 15.39, 8.31, 29.32, 23.23],
                // value: [4300, 10000, 28000, 35000, 50000, 19000],
                name: "",
                // symbol: "none",
                //这里的配置显示数值
                label: {
                  normal: {
                    show: true,
                    formatter: function (params) {
                      return params.value;
                    },
                  },
                },
              },
            ],
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(26, 239, 239, 0)",
                },
                {
                  offset: 1,
                  color: "#51DBDB",
                },
              ]),
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.$bus.$on("onfangdiangonglv", () => {
      this.getBattery24hours();
    });
    this.getBattery24hours();
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  methods: {
    //获取24小时电次数分布
    getBattery24hours() {
      let cityCode = this.query.province || this.query.city || "000000";
      let params = {
        enCode: "zngf-qg-j24xsgsdfdxl", // 接口code
        // 接口传参
        "@adcode": cityCode,
      };
      this.showcdata = false;
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "发电效率与收益排行榜");
          if (res) {
            let data = [];
            let data2 = [];
            let xAxis = [];
            res.forEach((item) => {
              xAxis.push(item.cur_hour); // 小时
              data.push(item.generate_electricity); // 发电效率
            });
            // this.cdata.xAxis.data = xAxis;
            // this.cdata.series[0].data = data;
            this.showcdata = true;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style></style>
